import { NgModule } from "@angular/core";
import { DynamicMibemCommandInputComponent } from './dynamic-mibem-command-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CodeScannerModule } from '../../code-scanner/code-scanner.module';
import { MibemCommandInputResultComponent } from './mibem-command-input-result/mibem-command-input-result.component';
import { MibemCommandInputDesignComponent } from './mibem-command-input-design/mibem-command-input-design.component';
import { MibemCommandInputFormComponent } from './mibem-command-input-form/mibem-command-input-form.component';
import { MibemCommandInputService } from './mibem-command-input.service';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
    declarations: [
        MibemCommandInputResultComponent,
        MibemCommandInputDesignComponent,
        MibemCommandInputFormComponent, DynamicMibemCommandInputComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatInputModule,
        MatFormFieldModule,
        CodeScannerModule,
    ],
    entryComponents: [
        DynamicMibemCommandInputComponent,
    ],
    providers: [
        MibemCommandInputService
    ]
})
export class MibemCommandInputModule {}